import { Modal } from 'antd';
import classNames from 'classnames';
import { ReactSVG } from 'react-svg';
import { t } from 'ttag';
import CustomButton from '../customButton';
import { closeIconV2 } from './assets';
import type { ModalNormalProps } from './types';
import './modalNormal.scss';

/**
 * Placeholder callback standing in for the modal's optional handlers. Takes no arguments and performs no work.
 *
 * @returns Nothing.
 */
const NOOP = () => {};

const ModalNormal = ({
  visible = false,
  title = 'Basic Title',
  handleSubmit = NOOP,
  handleCancel = NOOP,
  canceButtonlName = 'Cancel',
  submitButtonName = 'Submit',
  children = null,
  disableSubmitButton = false,
  disableCancelButton = false,
  hideCancelButton = false,
  loading = false,
  className = '',
}: ModalNormalProps) => (
  <Modal
    title={title}
    open={visible}
    centered
    maskClosable={false}
    onOk={handleSubmit}
    onCancel={handleCancel}
    closeIcon={
      <CustomButton
        id="close-btn"
        style="neutral"
        type="tertiary"
        icon={<ReactSVG src={closeIconV2} />}
        ariaLabel={t`Close`}
      />
    }
    wrapClassName={classNames('modal-normal', className)}
    footer={[
      !hideCancelButton && (
        <CustomButton
          id="cancel-btn"
          onClick={handleCancel}
          style="neutral"
          disabled={disableCancelButton}
        >
          {canceButtonlName}
        </CustomButton>
      ),
      <CustomButton
        id="submit-btn"
        onClick={handleSubmit}
        disabled={disableSubmitButton}
        loading={loading}
      >
        {submitButtonName}
      </CustomButton>,
    ]}
  >
    {children}
  </Modal>
);

export default ModalNormal;
